import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { useAuth } from "@/context/AuthContext";
import { apiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { AuthShell, GoogleButton } from "@/pages/authShared";
import { AlertCircle } from "lucide-react";

export default function Login() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    if (!email.trim() || !password) return setError("Veuillez saisir votre e-mail et votre mot de passe.");
    setLoading(true);
    try {
      const u = await login(email.trim(), password);
      toast.success("Connexion réussie");
      nav(u.role === "admin" ? "/admin" : "/compte");
    } catch (err) { setError(apiError(err)); } finally { setLoading(false); }
  };

  return (
    <AuthShell title="Connexion" subtitle="Accédez à votre espace et à vos eBooks."
      footer={<>Pas encore de compte ? <Link to="/inscription" className="text-terracotta hover:underline">Créer un compte</Link></>}>
      <form onSubmit={submit} className="space-y-4" noValidate>
        {error && (
          <div className="flex items-start gap-2 rounded-md border border-destructive/30 bg-destructive/5 p-3 text-sm text-destructive" data-testid="login-error">
            <AlertCircle className="h-4 w-4 mt-0.5 shrink-0" /><p>{error}</p>
          </div>
        )}
        <div><Label htmlFor="email">E-mail</Label><Input id="email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} className="bg-sand border-line mt-1" data-testid="login-email" /></div>
        <div><Label htmlFor="password">Mot de passe</Label><Input id="password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} className="bg-sand border-line mt-1" data-testid="login-password" /></div>
        <div className="text-right"><Link to="/mot-de-passe-oublie" className="text-xs text-ink-muted hover:text-terracotta">Mot de passe oublié ?</Link></div>
        <Button type="submit" disabled={loading} className="w-full bg-terracotta hover:bg-terracotta-dark text-white rounded-md" data-testid="login-submit">{loading ? "Connexion…" : "Se connecter"}</Button>
      </form>
      <div className="flex items-center gap-3 my-5"><div className="flex-1 h-px bg-line" /><span className="text-xs text-ink-muted">ou</span><div className="flex-1 h-px bg-line" /></div>
      <GoogleButton />
    </AuthShell>
  );
}
